/**
 * The hint for a studio server the cloud says is connected but this browser
 * cannot reach by its name (D16): what is probably wrong and what to do —
 * DNS rebinding protection on the router, an untrusted certificate, no answer
 * on the LAN, or another network (`connectivity/reachHint.ts` decides which).
 * Shown in the connectivity panel and a site's server list.
 *
 * Presentational: the hint comes in as a prop; nothing goes out.
 */
import { TriangleAlertIcon } from 'lucide-react';
import { LAN_DNS_DOCS, type ReachHint } from '../connectivity/reachHint.js';

export type ReachHintNoteProps = { readonly hint: ReachHint };

export function ReachHintNote({ hint }: ReachHintNoteProps) {
  return (
    <div className="flex max-w-sm items-start gap-1.5 text-xs" data-testid="reach-hint" data-case={hint.case}>
      <TriangleAlertIcon className="mt-0.5 size-3.5 shrink-0 text-warning" aria-hidden="true" />
      <div className="flex flex-col gap-0.5">
        <span className="font-medium text-warning">{hint.title}</span>
        <span className="text-muted-foreground">{hint.detail}</span>
        <span className="text-muted-foreground">
          See “LAN DNS” in the sites guide (<span className="font-mono">{LAN_DNS_DOCS}</span>).
        </span>
      </div>
    </div>
  );
}
